import SimpleUser from "../../../common/types/user/simple-user";
import { ConnectedAccount } from "../types/connected-account";

export const isAccountFromCountry = (
  userProfile: Partial<SimpleUser> | ConnectedAccount,
  country: string
) => {
  if (typeof userProfile.country === "string") {
    return userProfile.country.toUpperCase() === country;
  }

  if (userProfile.country && "id" in userProfile.country) {
    return userProfile?.country?.id?.toUpperCase() === country;
  }

  if ("address" in userProfile && "country" in userProfile.address) {
    return userProfile.address?.country?.id?.toUpperCase() === country;
  }

  return false;
};
